export default __webpack_public_path__ + "static/media/blue-background.9b99bdd7.svg";